<app-common-bulk-select-employee-dialog
    #selectEmployees
    headerText="forms.training.assignEmployees"
    label="save"
></app-common-bulk-select-employee-dialog>

<app-deprecated-confirmation-dialog
    #confirmDeleteDialog
    [description]="deleteMessage | translate: { numberOfEmployees: program?.enrolledCount }"
    label="{{ 'delete' | translate }}"
    [header]="'training.deleteModalTitle' | translate: { name: program?.name }"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<div class="ui basic segment program-show" [class.loading]="isLoading">
    <div class="app-grid">
        <app-header [title]="program.name" [back]="true" [contextMenu]="true" backRoute="/training/programs">
            <app-context-item label="{{ 'edit' | translate }}" (click)="onEdit()"> </app-context-item>
            <app-context-item label="{{ 'delete' | translate }}" (click)="onDelete()"> </app-context-item>
            <div class="buttons">
                <ui-button type="primary" (click)="onAssignClick()" *permission="'manageTrainingPrograms'">{{
                    'training.addRemoveEmployees' | translate
                }}</ui-button>
            </div>
        </app-header>
    </div>
    <div class="ui segment">
        <div class="app-grid">
            <app-segment-header title="{{ 'training.trainingProgramDetails' | translate }}"></app-segment-header>
            <div class="entity app-grid">
                <label class="columns-2 small-columns-12">{{ 'training.dueDate' | translate }}:</label>
                <span class="columns-10 small-columns-12" *ngIf="program.hasDueDate; else hasNoDueDate">
                    <span *ngIf="program.dueOffset > 1">
                        {{
                            'training.dueDateContent.plural'
                                | translate: { numberOfDays: program.dueOffset, afterEnrollmentDate: program.dueType }
                        }}</span
                    >
                    <span *ngIf="program.dueOffset === 1">
                        {{
                            'training.dueDateContent.singular'
                                | translate: { numberOfDays: program.dueOffset, afterEnrollmentDate: program.dueType }
                        }}</span
                    >
                </span>
                <ng-template #hasNoDueDate>
                    <span class="columns-10 small-columns-12">{{ 'training.noDueDate' | translate }}</span>
                </ng-template>
            </div>
            <div class="entity app-grid">
                <label class="columns-2 small-columns-12">{{ 'training.description' | translate }}:</label>
                <span
                    class="columns-10 small-columns-12"
                    *ngIf="program.description; else hasNoDescription"
                    [innerHTML]="program.description | sanitizeHtml"
                >
                </span>
                <ng-template #hasNoDescription>
                    <span class="columns-10 small-columns-12">{{ 'training.noDescription' | translate }}</span>
                </ng-template>
            </div>
            <div class="entity app-grid">
                <label class="columns-2 small-columns-12">{{ 'training.attachedFiles' | translate }}:</label>
                <span class="columns-10 small-columns-12 file-link"
                    ><span class="attachedFiles" *ngFor="let file of program.files" (click)="fileHelper.saveFile(file)">
                        <mat-icon [svgIcon]="file.name | fileIcon"></mat-icon>{{ file.name }}</span
                    >
                    <span class="columns-10 small-columns-12" *ngIf="!program.files.length">{{
                        'training.noAttachedFiles' | translate
                    }}</span>
                </span>
            </div>
            <div class="entity app-grid">
                <label class="columns-2 small-columns-12">{{ 'training.record' | translate }}:</label>
                <span
                    class="columns-10 small-columns-12"
                    *ngIf="
                        program.hasCost ||
                            program.hasCredits ||
                            program.hasHours ||
                            program.hasExpirationDate ||
                            program.hasInstructor ||
                            program.hasResult;
                        else hasNoRecord
                    "
                >
                    <span class="detail" *ngIf="program.hasCost">{{ 'training.cost' | translate }}:</span>
                    <span class="detail" *ngIf="program.hasCredits">{{ 'training.credits' | translate }}:</span>
                    <span class="detail" *ngIf="program.hasHours">{{ 'training.hours' | translate }}:</span>
                    <span class="detail" *ngIf="program.hasExpirationDate"
                        >{{ 'training.expirationDate' | translate }}:</span
                    >
                    <span class="detail" *ngIf="program.hasInstructor">{{ 'training.instructor' | translate }}:</span>
                    <span class="detail" *ngIf="program.hasResult">{{ 'training.resultPassfail' | translate }}</span>
                </span>
                <ng-template #hasNoRecord>
                    <span class="columns-10 small-columns-12">{{ 'training.nothingToRecord' | translate }}</span>
                </ng-template>
            </div>
            <div class="entity app-grid" *ngIf="program.isEmployeeSubmittable">
                <label class="columns-2 small-columns-10"></label>
                <span class="columns-10 small-columns-12">{{
                    'training.employeesAreAllowedToRecordOwnTraining' | translate
                }}</span>
            </div>
            <div class="entity app-grid">
                <label class="columns-2 small-columns-12">{{ 'training.programRepeat' | translate }}:</label>
                <span class="columns-10 small-columns-12" *ngIf="program.isRecurring; else isNotRecurring">
                    {{ program.recurrenceLabel | appTranslate }}
                    <span *ngIf="program.maxOccurrences">
                        {{
                            {
                                key: 'training.programEndsAfterNumberOfSessions',
                                params: { numberOfSessions: program.maxOccurrences },
                            } | appTranslate
                        }}
                    </span>
                </span>
                <ng-template #isNotRecurring>
                    <span class="columns-10 small-columns-12">{{ 'training.doesNotRepeat' | translate }}</span>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="ui segment">
        <app-table
            [table]="table"
            [showSearch]="false"
            [useStickyHeader]="false"
            [title]="'training.enrolledEmployees' | appTranslate"
            [embedded]="true"
            [isSmall]="true"
            [showHeader]="false"
        >
            <div class="empty">
                <h2 class="ui centered header">{{ 'training.noEmployeesAdded' | translate }}</h2>
            </div>
        </app-table>
    </div>
</div>
